<template>
  <div class="CertificatType-item-main" :class="{ 'CertificatType-item-main-mobile': isMobile}">
    <div class="pic" :style="{ backgroundImage: `url(${data.Icon})` }"></div>
    <div class="names">
      <div>{{data.line1}}</div>
      <div>{{data.line2}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CertificatTypeItem',
    props: { data: { type: Object, default: () => {} } }
  };
</script>
<style lang="scss" scoped>
  .CertificatType-item-main {
    border-radius: 0.03rem;
    width: 6.76rem;
    height: 4.27rem;
    background: #fff;
    box-shadow: 0 0.03rem 0.16rem 0.03rem rgb(226 226 226 / 59%);
    margin: 0 0.135rem;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
  }
  .pic {
    width: 5.08rem;
    height: 2.83rem;
    margin-top: 0.33rem;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .names {
    font-size: 0.27rem;
    font-family: PingFangTC-Regular, PingFangTC;
    font-weight: 400;
    color: #000000;
    line-height: 0.37rem;
    letter-spacing: 0.01rem;
    *{
      display: inline;
      margin-right: 0.1rem;
    }
  }
  .CertificatType-item-main-mobile {
    border-radius: 0.07rem;
    width: 8.29rem;
    height: 9.36rem;
    box-shadow: 0 0.1rem 0.41rem 0.1rem rgb(226 226 226 / 59%);
    margin: 0 0.305rem;
    .pic {
      width: 8.29rem;
      height: 4.81rem;
      margin-top: 0.41rem;
    }
    .names {
      margin-top: 1.23rem;
      font-size: 0.72rem;
      line-height: 1.02rem;
      color: rgba(0, 0, 0, 0.84);
      text-align: center;
      *{
        display: block;
        margin-right: 0;
      }
    }
  }
</style>
